import { Cookiebot } from '@external/cmp-cookiebot';

import { CookieConsentProvider, CookieConsentProviderState } from '../../cookie-consent.types';
import { mapCookiebotStateToCookieConsentProviderState } from './cookiebot.utils';

export class CookiebotProvider implements CookieConsentProvider {
  private config: { sdkUrl: string };

  constructor(params: { sdkUrl: string }) {
    this.config = { sdkUrl: params.sdkUrl };
  }

  async requestConsent(params: {
    onConsentGiven: (state: CookieConsentProviderState) => void;
    onError: (e: unknown) => void;
  }): Promise<void> {
    try {
      await new Promise((resolve, reject) =>
        Cookiebot.init({ sdkUrl: this.config.sdkUrl, onLoaded: () => resolve(true), onError: reject }),
      );
      await Cookiebot.requestConsent({
        onAccept: (state) => params.onConsentGiven(mapCookiebotStateToCookieConsentProviderState(state)),
        onDecline: (state) => params.onConsentGiven(mapCookiebotStateToCookieConsentProviderState(state)),
        onError: params.onError,
      });
    } catch (e: unknown) {
      params.onError(e);
    }
  }

  async renewConsent(params: {
    onConsentGiven: (state: CookieConsentProviderState) => void;
    onError: (e: unknown) => void;
  }): Promise<void> {
    try {
      await new Promise((resolve, reject) =>
        Cookiebot.init({ sdkUrl: this.config.sdkUrl, onLoaded: () => resolve(true), onError: reject }),
      );
      await Cookiebot.renewConsent({
        onAccept: (state) => params.onConsentGiven(mapCookiebotStateToCookieConsentProviderState(state)),
        onDecline: (state) => params.onConsentGiven(mapCookiebotStateToCookieConsentProviderState(state)),
        onError: params.onError,
      });
    } catch (e: unknown) {
      params.onError(e);
    }
  }
}
